module.exports = "/_next/static/images/tv-up-81be2cdef9f24d6034e6e5cf8cc4a208.png";